"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildQueryString = buildQueryString;
exports.getSkuInfoMapWithSkuMap = exports.getSkuInfoMapWithSkuInfoList = exports.getSkuInfoMapWithSkuList = exports.searchSkuWithoutAccount = exports.searchSku = exports.getValidSkuInfoMap = exports.getValidSkuInfo = exports.generateSkuListQuery = exports.fetchSceneForSku = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _fp = _interopRequireDefault(require("lodash/fp"));

var _chunk = _interopRequireDefault(require("lodash/chunk"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _pAll = _interopRequireDefault(require("p-all"));

var _skuSelectorMessages = require("./skuSelectorMessages");

var _logger = require("../logger");

function checkResponse(serviceComment, formatMessage) {
  return function (res) {
    if (res.ok) {
      if (res.status === 204) {
        return res;
      }

      return res.json();
    }

    throw new Error(formatMessage(_skuSelectorMessages.apiMessages.errorTemplate, {
      serviceComment: serviceComment,
      status: res.status
    }));
  };
}

function makeRequestHeader(onGetAccessToken) {
  return {
    Accept: 'application/json',
    Authorization: "Bearer ".concat(onGetAccessToken()),
    'Content-Type': 'application/json'
  };
}

var fetchSceneForSku = function fetchSceneForSku(sku, tenantId, onGetAccessToken, fetchId, formatMessage) {
  var endpointUrl = 'https://scenes.documents.cimpress.io';
  var body = {
    ReferenceId: sku,
    Tenant: {
      Id: tenantId,
      Type: 'fulfillers'
    }
  };
  var request = new Request("".concat(endpointUrl, "/v2/query"), {
    headers: makeRequestHeader(onGetAccessToken),
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(body)
  });
  return fetch(request).then(checkResponse(formatMessage(_skuSelectorMessages.apiMessages.sceneServiceComment), formatMessage)).then(function (response) {
    return response.Results[0] && {
      sceneUrl: response.Results[0].SceneUri,
      sku: response.Results[0].ReferenceId,
      fetchId: fetchId
    };
  });
};

exports.fetchSceneForSku = fetchSceneForSku;

var generateSkuListQuery = function generateSkuListQuery(skuList) {
  return skuList.map(function (sku) {
    return {
      type: 'match',
      fieldName: 'parentId',
      value: sku
    };
  });
};

exports.generateSkuListQuery = generateSkuListQuery;

function buildQueryString(key, values) {
  if (values === []) {
    return '';
  }

  var query = '';
  values.forEach(function (value) {
    if (query === '') {
      query = "".concat(key, "=").concat(value);
    } else {
      query = "".concat(query, "&").concat(key, "=").concat(value);
    }
  });
  return query;
}
/**
 * Checks if all skus in the provided sku list exist on the platform via the product discoverability service, and provides product details for any that do.
 * @param {Array<String>} skuList The list of skus to validate.
 * @param {Function} onGetAccessToken Function that provides the user's access token for authentication.
 * @param {Function} formatMessage Function used to internationalize messages for error formatting.
 * @returns {Object {mcpSku, failedToSearchSkus}} An object containing a list of product details for valid skus and a list of skus that could not be found.
 */


var getValidSkuInfo = function getValidSkuInfo(skuList, onGetAccessToken) {
  var formatMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return 'validating skus';
  };
  var endpointUrl = 'https://discover.products.cimpress.io';
  var body = {
    skuReferenceIds: skuList,
    fallback: true
  };
  var request = new Request("".concat(endpointUrl, "/v0/discover/skus"), {
    headers: makeRequestHeader(onGetAccessToken),
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(body)
  });
  return fetch(request).then(checkResponse(formatMessage(_skuSelectorMessages.apiMessages.discoverabilityServiceComment), formatMessage)).then(function (_ref) {
    var mcpSku = _ref.mcpSku,
        failedToSearchSkus = _ref.failedToSearchSkus;
    return {
      mcpSku: mcpSku,
      failedToSearchSkus: failedToSearchSkus
    };
  });
};

exports.getValidSkuInfo = getValidSkuInfo;

var getValidSkuInfoMap = function getValidSkuInfoMap(skuList, onGetAccessToken) {
  var skuBatchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var rateLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
  var formatMessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return 'validating skus';
  };
  var addNonExistentSkus = arguments.length > 5 ? arguments[5] : undefined;
  var batchedSkuList = (0, _chunk.default)(skuList, skuBatchSize);
  var batchedPromiseActions = batchedSkuList.map(function (skusToSearch) {
    return getValidSkuInfo(skusToSearch, onGetAccessToken, formatMessage).then(function (skuInfo) {
      var mcpSku = skuInfo.mcpSku,
          failedToSearchSkus = skuInfo.failedToSearchSkus;
      var skuInfoMap = (0, _keyBy.default)(mcpSku, function (sku) {
        return sku.referenceId;
      });
      return {
        skuInfoMap: skuInfoMap,
        failedToSearchSkus: failedToSearchSkus
      };
    });
  });
  return (0, _pAll.default)(batchedPromiseActions, {
    concurrency: rateLimit
  }).then(function (results) {
    var combinedSkuInfo = results.reduce(function (skuInfo, response) {
      var skuInfoMap = skuInfo.skuInfoMap,
          failedToSearchSkus = skuInfo.failedToSearchSkus;
      return {
        skuInfoMap: (0, _objectSpread2.default)({
          skuInfoMap: skuInfoMap
        }, response.skuInfoMap),
        failedToSearchSkus: [].concat((0, _toConsumableArray2.default)(failedToSearchSkus), (0, _toConsumableArray2.default)(response.failedToSearchSkus))
      };
    }, {
      skuInfoMap: {},
      failedToSearchSkus: []
    });

    if (addNonExistentSkus) {
      var skuInfoMap = combinedSkuInfo.skuInfoMap,
          failedToSearchSkus = combinedSkuInfo.failedToSearchSkus;
      var emptyInfoMap = failedToSearchSkus.reduce(function (infoMap, sku) {
        infoMap[sku] = {
          referenceId: sku
        };
        return infoMap;
      }, {});
      return {
        skuInfoMap: (0, _objectSpread2.default)({
          skuInfoMap: skuInfoMap
        }, emptyInfoMap),
        failedToSearchSkus: []
      };
    }

    return combinedSkuInfo;
  }).catch(function (e) {
    return {
      skuInfoMap: {},
      failedToSearchSkus: [],
      error: e
    };
  });
};

exports.getValidSkuInfoMap = getValidSkuInfoMap;

var searchSku = function searchSku(searchTerm, fulfillerIds, pageSize, page, onGetAccessToken, marketable, customQuery, formatMessage) {
  var endpointUrl = 'https://discover.products.cimpress.io';
  searchTerm = searchTerm || '';
  var maxLimit = 500;
  var elasticSearchSearchTerm = searchTerm.trim();
  var body = {
    query: elasticSearchSearchTerm,
    length: maxLimit
  };
  var request = new Request("".concat(endpointUrl, "/v0/search/products"), {
    headers: makeRequestHeader(onGetAccessToken),
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(body)
  });
  return fetch(request).then(checkResponse(formatMessage(_skuSelectorMessages.apiMessages.skuServiceComment), formatMessage)).then(function (result) {
    var skuMap = _fp.default.flow(_fp.default.map(function (response) {
      var productId = response.productId,
          name = response.name,
          description = response.description,
          version = response.version;
      return [productId, {
        referenceId: productId,
        sku: productId,
        sceneUrl: undefined,
        name: name,
        description: description,
        version: version
      }];
    }), _fp.default.fromPairs)(result);

    var count = result.length;
    return {
      count: count,
      skuMap: skuMap
    };
  }).catch(function (ex) {
    throw ex;
  });
};

exports.searchSku = searchSku;

var searchSkuWithoutAccount = function searchSkuWithoutAccount(pageSize, page, onGetAccessToken, customQuery, formatMessage) {
  var endpointUrl = 'https://introduction.products.cimpress.io';
  var request = new Request("".concat(endpointUrl, "/v1/products?").concat(customQuery), {
    headers: makeRequestHeader(onGetAccessToken),
    method: 'GET',
    mode: 'cors'
  });
  return fetch(request).then(checkResponse(formatMessage(_skuSelectorMessages.apiMessages.skuServiceComment), formatMessage)).then(function (result) {
    var skuMap = _fp.default.flow(_fp.default.map(function (response) {
      return [response.referenceId, {
        referenceId: response.referenceId,
        sku: response.referenceId,
        sceneUrl: undefined,
        name: response.name,
        description: response.description,
        version: response.productServiceVersion
      }];
    }), _fp.default.fromPairs)(result);

    var count = result.length;
    return {
      count: count,
      skuMap: skuMap
    };
  }).catch(function (ex) {
    throw ex;
  });
};
/**
 * Returns a sku information map given a list of skus.
 * Sku information contains name, description, and sceneUrl.
 * @param skuList
 * @param onGetAccessToken
 * @param marketable
 * @param addNonExistentSkus  if this is set to false, the sku will be excluded from the map if the description does not exist on the server.
 * @param skuBatchSize
 * @param rateLimit
 * @param formatMessage
 * @param onFinishedBatchFn function to call after a batch is finished. The result of skuSearch call will be passed in as an argument.
 * @returns {Promise<{ { skuMap, nonExistentSkuList, error } }>}
 */


exports.searchSkuWithoutAccount = searchSkuWithoutAccount;

var getSkuInfoMapWithSkuList = function getSkuInfoMapWithSkuList(skuList, onGetAccessToken, marketable) {
  var addNonExistentSkus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var skuBatchSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 500;
  var rateLimit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
  var formatMessage = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {
    return 'searching for skus';
  };
  var onFinishedBatchFn = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var nonExistentSkuList = [];
  var batchedSkuList = (0, _chunk.default)(skuList, skuBatchSize);
  var batchedPromiseActions = batchedSkuList.map(function (skuQuery) {
    return function () {
      var customSkuQueryString = buildQueryString('referenceId', skuQuery);
      return searchSkuWithoutAccount(skuQuery.length, 1, onGetAccessToken, customSkuQueryString, formatMessage).then(function (searchResult) {
        // pass the result onto onFinishedBatchFn if it is not null.
        onFinishedBatchFn && onFinishedBatchFn(searchResult);
        return searchResult;
      });
    };
  });
  var logger = (0, _logger.getLoggerForToken)(onGetAccessToken);
  return (0, _pAll.default)(batchedPromiseActions, {
    concurrency: rateLimit
  }).then(function (results) {
    var skuInfoMap = {};
    results.forEach(function (result, index) {
      var query = batchedSkuList[index];
      var skuMap = result.skuMap;
      query.forEach(function (sku) {
        // if sku was not found in the search
        if (!skuMap[sku]) {
          // if sku was not found from the search, but the flag is on, add it.
          if (addNonExistentSkus) {
            skuInfoMap[sku] = {
              sku: sku
            };
          } else {
            nonExistentSkuList.push(sku);
          }
        } else {
          skuInfoMap[sku] = skuMap[sku];
        }
      });
    });
    return {
      skuMap: skuInfoMap,
      nonExistentSkuList: nonExistentSkuList
    };
  }).catch(function (e) {
    logger.error('Error in fetching sku details', 'skuSearch/services');

    if (addNonExistentSkus) {
      var skuInfoMap = skuList.reduce(function (skuMap, sku) {
        skuMap[sku] = {
          sku: sku
        };
        return skuMap;
      }, {});
      return {
        skuMap: skuInfoMap,
        nonExistentSkuList: [],
        error: null
      };
    }

    return {
      skuMap: {},
      nonExistentSkuList: [],
      error: e
    };
  });
};
/**
 * Returns a skuMap with sku information (name, description, sceneUrl) properties added for all skus.
 * Existing properties will be persisted (but the sku information field will be overwritten if it exists).
 * If the data doesn't exist for the sku, it will not be modified.
 * @param skuInfoListToPopulate
 * @param onGetAccessToken
 * @param marketable
 * @param skuBatchSize
 * @param rateLimit
 * @param formatMessage
 * @param onFinishedBatchFn function to call after a batch is finished. The result of skuSearch call will be passed in as an argument.
 * @returns {Promise<{ { skuMap, error } }>}
 */


exports.getSkuInfoMapWithSkuList = getSkuInfoMapWithSkuList;

var getSkuInfoMapWithSkuInfoList = function getSkuInfoMapWithSkuInfoList(skuInfoListToPopulate, onGetAccessToken, marketable) {
  var skuBatchSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var rateLimit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
  var formatMessage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
    return 'searching for skus';
  };
  var onFinishedBatchFn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var skus = skuInfoListToPopulate.map(function (skuInfo) {
    return skuInfo.sku;
  });
  return getSkuInfoMapWithSkuList(skus, onGetAccessToken, marketable, true, skuBatchSize, rateLimit, formatMessage, onFinishedBatchFn).then(function (_ref2) {
    var skuMap = _ref2.skuMap,
        error = _ref2.error;
    var newSkuMap = skus.reduce(function (map, sku, index) {
      map[sku] = (0, _objectSpread2.default)({}, skuInfoListToPopulate[index], skuMap[sku]);
      return map;
    }, {});
    return {
      skuMap: newSkuMap,
      error: error
    };
  }).catch(function (e) {
    return {
      skuMap: {},
      error: e
    };
  });
};
/**
 * Returns a new skuMap with sku information (name, description, sceneUrl) properties added for all skus.
 * Existing properties will be persisted (but the sku information field will be overwritten if it exists).
 * If the data doesn't exist for the sku, it will not be modified.
 * @param skuMapToPopulate
 * @param onGetAccessToken
 * @param marketable
 * @param skuBatchSize
 * @param rateLimit
 * @param formatMessage
 * @param onFinishedBatchFn function to call after a batch is finished. The result of skuSearch call will be passed in as an argument.

 * @returns {Promise<{ { skuMap, error } }>}
 */


exports.getSkuInfoMapWithSkuInfoList = getSkuInfoMapWithSkuInfoList;

var getSkuInfoMapWithSkuMap = function getSkuInfoMapWithSkuMap(skuMapToPopulate, onGetAccessToken, marketable) {
  var skuBatchSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var rateLimit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
  var formatMessage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
    return 'searching for skus';
  };
  var onFinishedBatchFn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var skuList = Object.keys(skuMapToPopulate);
  return getSkuInfoMapWithSkuList(skuList, onGetAccessToken, marketable, true, skuBatchSize, rateLimit, formatMessage, onFinishedBatchFn).then(function (_ref3) {
    var skuMap = _ref3.skuMap,
        error = _ref3.error;
    var newSkuMap = skuList.reduce(function (map, sku) {
      map[sku] = (0, _objectSpread2.default)({}, skuMapToPopulate[sku], skuMap[sku]);
      return map;
    }, {});
    return {
      skuMap: newSkuMap,
      error: error
    };
  }).catch(function (e) {
    return {
      skuMap: {},
      error: e
    };
  });
};

exports.getSkuInfoMapWithSkuMap = getSkuInfoMapWithSkuMap;